import React from 'react';
import { BoldTitle, SubTitle } from '../../../CustomizedComponents/Texts';
import SectionWrapper from '../../../CardRow/SectionWrapper';
import { FormattedMessage } from 'react-intl';
import CustomCheckBox from '../../../CustomizedComponents/CustomCheckBox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import PropTypes from 'prop-types';

const TradingDays = (
  {
    data,
    handler,
    editable,
  },
) => {
  const days = 'app.configuration.days';
  const bestAsk = 'app.configuration.bestAsk';
  const trading = 'app.configuration.trading';

  return (
    <>
      <SectionWrapper>
        <BoldTitle title={days} />
        <SubTitle title={bestAsk} />
        <div>
          <FormGroup>
            <FormControlLabel
              control={
                <CustomCheckBox
                  checked={data?.isTrading}
                  disabled={!editable}
                  onChange={
                    (event) => {
                      const target = event.target;
                      handler((oldState) => {
                        return { ...oldState, isTrading: target.checked };
                      });
                    }
                  }
                />
              }
              label={<FormattedMessage
                id={trading}
              />}
            />
          </FormGroup>
        </div>
      </SectionWrapper>
    </>
  );
};

TradingDays.propTypes = {
  data: PropTypes.object,
  editable: PropTypes.bool,
  handler: PropTypes.func,
};

export default TradingDays;
